import AsyncSelect from 'lib/AsyncSelect';
import { SelectHandler } from 'lib/AsyncSelect/AsyncSelect.types';
import { Agency } from 'components/common/types/Deal.types';
import { FilterAgencyProps } from './FilterAgency.types';
import { useLoadLookup } from '../useLoadLookup';

const FilterAgency: React.FC<
  Omit<FilterAgencyProps, 'loadData' | 'onSelect' | 'selectedValue' | 'name' | 'textKey'>
> = ({ agency, changeFilters }) => {
  const { onLoadLookup } = useLoadLookup();

  const handleSelectAgency: SelectHandler<Agency> = (_, value: Agency): void => {
    changeFilters({ agency: value });
  };

  return (
    <AsyncSelect
      name="agency"
      selectedValue={agency}
      loadData={onLoadLookup}
      onSelect={handleSelectAgency}
      placeholder="Search agency"
      dataTestId="agency-filter"
      textKey="name"
    />
  );
};

export default FilterAgency;
